import type { FC } from 'react';
import { alpha, Button, Stack, Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import { useRecoilValue } from 'recoil';

import useGetTokenData from 'hooks/api/queries/useGetTokenData';
import selectedDateState from 'atoms/selectedDate';

const headerItemsSx: SxProps<Theme> = {
  opacity: 1,
  bgcolor: (theme) => alpha(theme.palette.common.grey, 0.15),
  color: (theme) => `${theme.palette.common.grey} !important`,
  textTransform: 'capitalize',
};

const Header: FC = () => {
  const selectedDate = useRecoilValue(selectedDateState);
  const { data } = useGetTokenData({ keepPreviousData: true }, selectedDate);

  return (
    <Stack direction="row">
      <Stack width={[0.5, undefined, undefined, 1 / 3]} pr={0.5}>
        <Button
          variant="text"
          component="div"
          color={'disabled' as any}
          sx={headerItemsSx}
          disabled
        >
          {process.env.REACT_APP_VAULT_CONTEXT}
        </Button>
      </Stack>

      {data?.organizationName && (
        <Stack width={[0.5, undefined, undefined, 1 / 3]} pl={0.5}>
          <Button
            variant="text"
            component="div"
            color={'disabled' as any}
            sx={headerItemsSx}
            disabled
          >
            {data.organizationName}
          </Button>
        </Stack>
      )}
    </Stack>
  );
};

export default Header;
